import React from "react";
import classes from "./CarouselPagination.module.css";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";

function CarouselPagination({ pages, activePage, onClick }) {
  const lastIndex = pages.length - 1;

  return (
    <div className={`cus_b ${classes.pagination}`}>
      <button
        onClick={() => onClick(activePage - 1)}
        disabled={activePage == 0 && true}
      >
        <BiLeftArrowAlt
          className={`${classes.arrow} ${
            activePage == 0 ? classes.arrowDisabled : classes.arrowColor
          }`}
        />
      </button>
      {pages.map((page) => {
        return (
          <div
            className={
              activePage === page ? classes.radioSelected : classes.radio
            }
            key={page}
            onClick={() => onClick(page)}
          />
        );
      })}
      <button
        onClick={() => onClick(activePage + 1)}
        disabled={activePage == lastIndex && true}
      >
        <BiRightArrowAlt
          className={`${classes.arrow} ${
            activePage == lastIndex ? classes.arrowDisabled : classes.arrowColor
          }`}
        />
      </button>
    </div>
  );
}

export default CarouselPagination;
